// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-criteria-setting {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 0 32px;
}

.fund-criteria-setting:not(:last-child) {
  border-bottom: 1px solid var(--border-line);
}

.fund-criteria-setting-no-data {
  color: var(--text-label);
  padding: 8px 0;
}

.fund-criteria-setting-header {
  display: flex;
  align-items: center;
  gap: 2px;
}

.fund-criteria-setting-header-title {
  flex: 1 0 0;
  color: var(--text-subheader);
  text-align: left;
}

.fund-criteria-setting-header-close {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  cursor: pointer;
}

.fund-criteria-setting-slider-container {
  padding: 4px 24px;
}

.fund-criteria-setting-input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fund-criteria-setting-input {
  box-sizing: border-box;
  width: 120px;
  height: 40px;
  padding: 8px 12px;
  background-color: var(--surface-tertiary);
  border: 1px solid var(--border-input);
  border-radius: 4px;
  text-align: center;
  color: var(--text-input-2);
}

.fund-criteria-setting-input-label {
  color: var(--text-label);
}

.fund-criteria-setting-score-chips {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
}

.fund-criteria-setting-score-chip {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid var(--border-secondary);
  background-color: var(--row-light);
  color: var(--border-secondary);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.fund-criteria-setting-score-chip.na {
  font-size: 12px;
  font-weight: 500;
}

.fund-criteria-setting-score-chip.outlined {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.fund-criteria-setting-score-chip.solid {
  border-color: var(--accent-primary);
  background-color: var(--accent-primary);
  color: var(--text-invert);
}

.fund-criteria-setting-search {
  position: relative;
}

.fund-criteria-setting-search-input {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
}

.fund-criteria-setting-search-input:focus {
  outline: none;
}

.fund-criteria-setting-search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--row-light);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  box-shadow: 0 0 12px 0 rgba(18, 18, 18, 0.05);
  padding: 8px 1px;
}

/* Same treatment as .fund-single-select-option-item, just 40px tall. */
.fund-criteria-setting-search-option {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  cursor: pointer;
  color: var(--text-primary);
}

.fund-criteria-setting-search-option:hover {
  background-color: var(--color-brand-hover2);
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/FundCriteriaSetting/FundCriteriaSetting.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".fund-criteria-setting {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  padding: 16px 0 32px;\n}\n\n.fund-criteria-setting:not(:last-child) {\n  border-bottom: 1px solid var(--border-line);\n}\n\n.fund-criteria-setting-no-data {\n  color: var(--text-label);\n  padding: 8px 0;\n}\n\n.fund-criteria-setting-header {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.fund-criteria-setting-header-title {\n  flex: 1 0 0;\n  color: var(--text-subheader);\n  text-align: left;\n}\n\n.fund-criteria-setting-header-close {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.fund-criteria-setting-slider-container {\n  padding: 4px 24px;\n}\n\n.fund-criteria-setting-input-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.fund-criteria-setting-input {\n  box-sizing: border-box;\n  width: 120px;\n  height: 40px;\n  padding: 8px 12px;\n  background-color: var(--surface-tertiary);\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  text-align: center;\n  color: var(--text-input-2);\n}\n\n.fund-criteria-setting-input-label {\n  color: var(--text-label);\n}\n\n.fund-criteria-setting-score-chips {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 16px;\n}\n\n.fund-criteria-setting-score-chip {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 3px solid var(--border-secondary);\n  background-color: var(--row-light);\n  color: var(--border-secondary);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.fund-criteria-setting-score-chip.na {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.fund-criteria-setting-score-chip.outlined {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.fund-criteria-setting-score-chip.solid {\n  border-color: var(--accent-primary);\n  background-color: var(--accent-primary);\n  color: var(--text-invert);\n}\n\n.fund-criteria-setting-search {\n  position: relative;\n}\n\n.fund-criteria-setting-search-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n}\n\n.fund-criteria-setting-search-input:focus {\n  outline: none;\n}\n\n.fund-criteria-setting-search-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--row-light);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  box-shadow: 0 0 12px 0 rgba(18, 18, 18, 0.05);\n  padding: 8px 1px;\n}\n\n/* Same treatment as .fund-single-select-option-item, just 40px tall. */\n.fund-criteria-setting-search-option {\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  height: 40px;\n  padding: 0 16px;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.fund-criteria-setting-search-option:hover {\n  background-color: var(--color-brand-hover2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
